import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password-email-sent',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './forgot-password-email-sent.component.html',
  styleUrl: './forgot-password-email-sent.component.css'
})
export class ForgotPasswordEmailSentComponent {

  email: string;

  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    this.email = navigation?.extras?.state?.['email'] || '';
    if (!this.email) {
      this.router.navigate(['/login']);
    }
  }


  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }

  getYear() {
    return new Date().getFullYear();
  }

}
